"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pxToNum = function pxToNum(val) {
  return parseInt(val.slice(0, -2), 10);
};
exports.pxToNum = pxToNum;


//////////////////
// WEBPACK FOOTER
// ./~/react-burger-menu/lib/utils.js
// module id = 31
// module chunks = 35783957827783 114276838955818 267625579013595